import { useMemo } from "react";
import { useQuery } from "react-query";
import { listFeatureFlagsByPrefix } from "../api/featureAccess";
import { EXPERIMENT_FLAG_PREFIX } from "../components/Experiments/experimentsManifest";

/**
 * Returns the set of `exp_iso_*` feature flags the given user has access to.
 * The tab + sub-items in the Experiments menu are derived from this set
 * intersected with the lab's experiments manifest.
 *
 * Returns an empty set while loading or when no user is signed in.
 */
export const useEnabledExperimentFlags = (userId) => {
  const query = useQuery(
    ["experimentFlags", userId],
    () => listFeatureFlagsByPrefix(EXPERIMENT_FLAG_PREFIX, userId),
    {
      enabled: !!userId,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  );

  // Memoize the Set so the reference is stable between renders when
  // `query.data` hasn't changed. This avoids triggering effects/memos in
  // consumers that depend on `flags`. Always return a hook-owned Set (never a
  // shared module-level instance) so an accidental consumer mutation can't
  // leak across the app.
  const flags = useMemo(() => new Set(query.data || []), [query.data]);

  return {
    ...query,
    flags,
  };
};
